import { aboutParagraphs, artemulkImages } from "../../data/artemulkContent";

const AboutUs = () => {
  return (
    <div className="pt-16 pb-12">
      <div className="flex flex-wrap gap-12 lg:gap-16 items-center">
        <div className="relative flex-1 basis-[18rem] min-h-[260px]">
          <img
            src={`${artemulkImages.aboutMain}?v=corp`}
            alt="Arte Mülk Hakkımızda"
            className="object-cover object-center w-full h-full min-h-[280px] max-h-[420px] rounded-[25px] border border-gray-200 dark:border-gray-700"
          />
        </div>

        <div className="flex-1 basis-[22rem] min-w-[280px]">
          <span className="sub-heading">Kurumsal</span>
          <h2 className="heading">Hakkımızda</h2>
          <div className="mt-4 space-y-4">
            {aboutParagraphs.map((text) => (
              <p key={text.slice(0, 40)} className="leading-relaxed text-muted">
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
